import { logger as m } from "../../../utils/logger.js";
import { SERVICE as c } from "../../compass/services.js";
import { cacheDecorator as l } from "../utils/decorator-cache.js";
const d = /* @__PURE__ */ new Map();
function a(r, e) {
  return l(
    `csrf-${r}`,
    () => e("/api/session/info").json().then((s) => s.csrfToken),
    1
  );
}
async function f(r) {
  return r.status !== 403 ? !1 : (await r.clone().json()).errorcode === "ERROR_ACCESS_FORBIDDEN_CSRF_KO";
}
const C = "x-ds-iam-csrftoken";
async function I(r, e) {
  return (await e("/api/authenticated/user/fields")).headers.get(C);
}
async function w(r) {
  return r.status !== 403 ? !1 : await r.clone().text() === "The CSRF token cannot be validated";
}
const E = "x-ds-csrftoken";
async function y(r, e) {
  return (await e("/resources/3ddrive/v1/bos/DSROOT")).headers.get(E);
}
async function _(r) {
  return r.status === 403;
}
const o = {
  [c.PASSPORT]: {
    header: C,
    fetch: I,
    checkIsCsrfError: w
  },
  [c.DRIVE]: {
    header: E,
    fetch: y,
    checkIsCsrfError: _
  },
  [c.SPACE]: {
    header: "x-ds-csrftoken",
    fetch: void 0,
    checkIsCsrfError: void 0
  },
  [c.SWYM]: {
    header: "x-ds-swym-csrftoken",
    fetch: a,
    checkIsCsrfError: f
  },
  [c.COMMENT]: {
    header: "x-ds-swym-csrftoken",
    fetch: a,
    checkIsCsrfError: f
  },
  [c.SEARCH]: {
    header: "x-ds-swym-csrftoken",
    fetch: a,
    checkIsCsrfError: f
  }
};
function S(r, e) {
  d.set(r, e || sessionStorage.getItem(`${r}_csrf`) || ""), e && sessionStorage.setItem(`${r}_csrf`, e);
}
function T(r) {
  return async (e, s) => {
    const t = d.get(r);
    if (!t)
      return;
    const n = o[r].header;
    e.headers.set(n, t), s.headers.set(n, t);
  };
}
function g(r, e) {
  if (e.status < 300) {
    const s = e.headers.get(o[r].header);
    s && S(r, s);
  }
}
async function P(r, e) {
  var s, t;
  try {
    const n = await ((t = (s = o[r]).fetch) == null ? void 0 : t.call(s, r, e));
    n && S(r, n);
  } catch (n) {
    m.error(`Failed to fetch CSRF for ${r}`, n);
  }
}
function x(r, e) {
  return async (s, t, n) => {
    var i, h;
    if (g(r, n), !await ((h = (i = o[r]).checkIsCsrfError) == null ? void 0 : h.call(i, n)))
      return;
    await P(r, e), t.json && delete t.body;
    const { Preferences: R } = await import("@3ds/common-preferences"), { CommonRequest: k } = await import("@3ds/common-request-proxification");
    if (R.isNativeApp() && k.checkHasProxyPath(s.url)) {
      const u = new URL(s.url).searchParams.get("url");
      if (u)
        return e(u, t);
    }
    return e(s, t);
  };
}
export {
  d as CSRF,
  x as handleCsrfError,
  S as initCsrfFromTokenOrSessionStorage,
  T as setCsrfOnHeader
};
